import { render, staticRenderFns } from "./HoverText.vue?vue&type=template&id=7d38e2b0&"
import script from "./HoverText.vue?vue&type=script&lang=js&"
export * from "./HoverText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports